import MrdPage from "./MrdPage";

export default MrdPage